export default __webpack_public_path__ + "static/media/SWG.2247e4af.jpg";